export const customerLang = {
	label: {
		createCustomer: 'Create Customer',
		createDesign: 'Create a Design',
		downloadBlueprint: 'Download Blueprint',
		downloadDiagnostics: 'Download Diagnostics',
		importBlueprint: 'Import Blueprint',
		loadMoreDesigns: 'Load More',
		manageDesigns: 'Manage Designs',
		findCustomer: 'Find Customer',
		firstName: 'First Name',
		lastName: 'Last Name',
		loadCustomer: 'Load Customer',
		newCustomer: 'New Customer',
		noRecentCustomers: 'No recent entries found.',
		phone: 'Phone',
		zipcode: 'Zip Code',
		recentCustomers: 'Recent Customers',
		saveSubmission: 'Save Current Submission',
		customerPlaceholder: 'Search a customer by email or name.',
		customerEmail: 'Customer Email',
		autoSaveSubmission: 'Auto Save Submission',
		deleteCustomerDrafts: 'Delete Customer Drafts',
		deleteAllDrafts: 'Delete All Drafts',
		pushSubmission: 'Push To Test',
		reportBug: 'Report a Bug',
		reportBugDescription: 'Description',
		reportBugSubmit: 'Submit',
		reportBugSuccessTitle: 'Bug Report Submitted'
	},
	text: {
		createDesignToStart: 'Create a design to get started',
		findCustomer: 'Find a customer with existing blueprint..',
		noCustomerFound: 'No customer found with that email. Create a new contact below.',
		hubspotMatches: 'Matching HubSpot contacts:',
		reportBugDescriptionPlaceholder: 'What happened? What did you expect to happen?'
	},
	tooltip: {
		clickToFindCustomer: 'Click to find customer',
		clickToAddCustomer: 'Click to Add a New Customer',
		downloadBlueprint: 'Click to Download the Current Blueprint',
		downloadDiagnostics: 'Click to Download the Blueprint and Console Logs for Bug Reports',
		importBlueprint: 'Click to Import a Blueprint File (.rbp)',
		importBlueprintNoCustomer: 'Load or select a customer before importing a blueprint',
		loadMoreDesigns: 'Load the next designs for this customer',
		manageDesigns: 'See every design by name and choose which ones load first',
		noMoreDesigns: 'Every design for this customer is loaded',
		designNotLoaded: 'Not loaded yet — use Load More to open this design',
		blueprintFileMenu: 'Blueprint file: download, import, or download diagnostics',
		reportBug: 'Click to describe and submit a bug report',
		noController: 'No blueprint available',
		notDirty: 'No changes to save',
		saveDesign: 'Click to Save the Current Design',
		saveDraftAsNewVersion: 'Save draft as new version',
		readOnly: 'Read-only mode',
		pushSubmission: 'Push the current submission to the test environment',
		pushSubmissionDisabled: 'Select a design to enable this feature',
		deleteCustomerDrafts: 'Delete Customer Drafts',
		noCustomerDrafts: 'No drafts available for this customer',
		deleteAllDrafts: 'Delete All Drafts',
		noDrafts: 'No drafts available',
		delete: 'Delete'
	},
	message: {
		openCustomerWarning: 'This action will close the current customer',
		errorFetchingUser: 'Error fetching user',
		createCustomerFailed: 'Failed to create customer. Please try again.',
		invalidEmail: 'Enter a valid email address.',
		customerNotFound: 'Customer not found in Hubspot. Check your entry and try again.',
		saveFailed: 'Blueprint save failed. Please try again.',
		saveSuccess: 'Blueprint saved successfully',
		importBlueprintSuccess: 'Blueprint imported successfully',
		importBlueprintFailed: 'Failed to import blueprint. Check that the file is a valid .rbp.',
		downloadDiagnosticsSuccess: 'Diagnostics bundle downloaded successfully',
		downloadDiagnosticsFailed: 'Failed to download diagnostics bundle. Please try again.',
		pushSubmission: 'This action will push the current submission to the test environment. Do you want to proceed?',
		pushSubmissionSuccess: 'Submission pushed successfully',
		pushSubmissionFailed: 'Submission push failed',
		deleteCustomerDraftsWarning: 'This action will delete all drafts for this customer',
		customerDraftsDeleted: 'Customer drafts deleted.',
		deleteAllDraftsWarning: 'This action will delete all drafts for all customers',
		allDraftsDeleted: 'All drafts deleted.',
		deleteCustomerBlueprintWarning: 'This action will delete the current customer blueprint. Do you want to proceed?',
		deleteCustomerBlueprintFailed: 'Failed to delete the blueprint. Please try again.',
		reportBugSuccess: 'Thanks -- your bug report was submitted.',
		reportBugFailed: 'Failed to submit bug report. Please try again.',
		designOrderSaved: 'Design order saved',
		designOrderFailed: 'Failed to save the design order. Please try again.',
		designOrderHelp: 'The designs above the line load first when this customer opens. The rest load with Load More, newest first.',
		noDesignsToOrder: 'No designs to order yet.',
		reportBugSessionExpired: 'Your session has expired. Please log out and log back in, then submit your bug report again.'
	}
};
